import './App.css';
import React from 'react';
import Navbar from './components/Navbar';
import Shop from './components/Shop';

function App() {
  return (
    <>
      <Navbar />
      <Shop />
    </>
  );
}

export default App;
